/* import __COLOCATED_TEMPLATE__ from './type-filter.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface TypeFilterArgs {
  availableTypes: string[];
  selectedTypes: string[];
  onFilterChange: (selected: string[]) => void;
}

const ICON_LOOKUP: Record<string, string> = {
  'fin attributes': 'fin',
  text: 'small-text',
  number: 'numbers',
  'decimal number': 'decimal',
  boolean: 'boolean',
  'true or false': 'boolean',
  list: 'list',
  'data & time': 'calendar',
  reference: 'reference',
  'file upload': 'attachment',
};

function normalizeType(type: string): string {
  return (type || '').toLowerCase();
}

export default class TypeFilter extends Component<TypeFilterArgs> {
  @service declare intl: IntlService;

  get items() {
    let types = this.args.availableTypes || [];
    return [
      {
        items: types.map((type: string) => {
          let text = type;
          let icon = ICON_LOOKUP[normalizeType(text)] || '';
          return {
            text,
            value: text,
            icon,
            isSelected: this.args.selectedTypes?.includes(text),
          };
        }),
      },
    ];
  }

  get selectedTypeText() {
    if (Array.isArray(this.args.selectedTypes) && this.args.selectedTypes.length > 0) {
      return this.args.selectedTypes.join(', ');
    }
    return this.intl.t('settings.conversation-attributes.type-filter.any');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::ConversationAttributes::TypeFilter': typeof TypeFilter;
    'settings/conversation-attributes/type-filter': typeof TypeFilter;
  }
}
